import { Button } from '@welbe/design-system';
import { Pencil } from 'App/assets/icons';
import { StatusCell } from '../UsersTable/StatusCell';

export const formattedRows = (
	data: any,
	handleSelectUser: (row: any) => void,
) => {
	return (
		data?.map((row: any) => ({
			id: row.id,
			name: row.name,
			role: row?.role?.name,
			status: <StatusCell key={row.status} status={row.status} />,
			edit: (
				<Button
					fontSize="xs"
					variant="ghost"
					onClick={() => handleSelectUser(row)}
				>
					<Pencil />
				</Button>
			),
		})) ?? []
	);
};
